import { ThemeProvider } from '@mui/material/styles';
import { ReactNode, useEffect, useMemo } from 'react';
import getTheme from '@styles/theme/theme.ts';
import useOrganizationBrandingStore from '@store/organization-branding-store/organization-branding.store.ts';
import { hexToRgba } from '@utils/cropedImage.utils.ts';

interface Props {
  children: ReactNode;
}

const DynamicThemeProvider = ({ children }: Props) => {
  const primaryColor = useOrganizationBrandingStore(
    (state) => state.primaryColor
  );

  useEffect(() => {
    if (primaryColor) {
      document.documentElement.style.setProperty('--primary', primaryColor);

      const transparencies = {
        '--primary-50': 0.05,
        '--primary-100': 0.1,
        '--primary-200': 0.2,
        '--primary-300': 0.3,
        '--primary-400': 0.4,
        '--primary-500': 0.5,
        '--primary-600': 0.6,
        '--primary-700': 0.7,
        '--primary-800': 0.8,
        '--primary-900': 0.9
      };

      for (const [name, alpha] of Object.entries(transparencies)) {
        const rgba = hexToRgba(primaryColor, alpha);
        document.documentElement.style.setProperty(name, rgba);
      }
    }
  }, [primaryColor]);

  const theme = useMemo(
    () => getTheme(primaryColor ?? undefined),
    [primaryColor]
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default DynamicThemeProvider;
